// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const ANNOTATE_ANTIBODY_INPUTS_STEP_SHAPES = [
  {
    stepType: PipelineStepType.ANNOTATE_ANTIBODY_INPUTS,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {
      'Input file': {
        systemName: 'Input file',
        displayName: 'Input file',
        kind: PipelineStepDataKind.FILE,
        isMulti: false,
        isRequired: true
      }
    },
    outputDataShapes: {
      'Output file': {
        systemName: 'Output file',
        displayName: 'Annotated Antibody Create Inputs',
        kind: PipelineStepDataKind.FILE,
        isMulti: false,
        isRequired: true
      },
      'DNA annotation output': {
        systemName: 'DNA annotation output',
        displayName: 'DNA annotation output',
        kind: PipelineStepDataKind.FILE,
        isMulti: false,
        isRequired: false
      },
      'AA annotation output': {
        systemName: 'AA annotation output',
        displayName: 'AA annotation output',
        kind: PipelineStepDataKind.FILE,
        isMulti: false,
        isRequired: false
      }
    },
    config: {}
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
